export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8720.7d4e73d7.jpg";